import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useReducedMotion } from "@/hooks/use-reduced-motion";

export function Marquee({
  children,
  className,
  durationSeconds = 40,
}: {
  children: ReactNode;
  className?: string;
  durationSeconds?: number;
}) {
  const reduced = useReducedMotion();
  if (reduced) {
    return (
      <div className={cn("flex flex-wrap items-center justify-center gap-12", className)}>
        {children}
      </div>
    );
  }
  return (
    <div
      className={cn("group relative flex w-full overflow-hidden", className)}
      aria-hidden="true"
    >
      <div
        className="flex shrink-0 animate-marquee items-center gap-16 pr-16"
        style={{ animationDuration: `${durationSeconds}s` }}
      >
        {children}
      </div>
      <div
        className="flex shrink-0 animate-marquee items-center gap-16 pr-16"
        style={{ animationDuration: `${durationSeconds}s` }}
        aria-hidden="true"
      >
        {children}
      </div>
    </div>
  );
}
